var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import IconClose from '../../icon/react-icon/IconClose';
import IconCheckCircleFill from '../../icon/react-icon/IconCheckCircleFill';
import IconCloseCircleFill from '../../icon/react-icon/IconCloseCircleFill';
import IconInfoCircleFill from '../../icon/react-icon/IconInfoCircleFill';
import IconExclamationCircleFill from '../../icon/react-icon/IconExclamationCircleFill';
import IconLoading from '../../icon/react-icon/IconLoading';
import cs from '../_util/classNames';
var Notice = /** @class */ (function (_super) {
    __extends(Notice, _super);
    function Notice() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.startTimer = function () {
            var _a = _this.props, duration = _a.duration, onClose = _a.onClose, id = _a.id;
            // 自动关闭
            if (duration !== 0) {
                _this.timer = window.setTimeout(function () {
                    onClose && onClose(id);
                    _this.removeTimer();
                }, duration);
            }
        };
        _this.removeTimer = function () {
            if (_this.timer) {
                window.clearTimeout(_this.timer);
                _this.timer = null;
            }
        };
        _this.onClose = function () {
            _this.props.onClose && _this.props.onClose(_this.props.id);
        };
        _this.renderIcon = function () {
            var _a = _this.props, showIcon = _a.showIcon, icon = _a.icon, type = _a.type;
            var content;
            if (icon) {
                content = icon;
            }
            else if (showIcon) {
                switch (type) {
                    case 'info':
                        content = React.createElement(IconInfoCircleFill, { className: "info" });
                        break;
                    case 'success':
                        content = React.createElement(IconCheckCircleFill, { className: "success" });
                        break;
                    case 'error':
                        content = React.createElement(IconCloseCircleFill, { className: "error" });
                        break;
                    case 'warning':
                        content = React.createElement(IconExclamationCircleFill, { className: "warning" });
                        break;
                    case 'loading':
                        content = React.createElement(IconLoading, { className: "loading" });
                        break;
                    default:
                        break;
                }
            }
            return content;
        };
        return _this;
    }
    Notice.prototype.componentDidMount = function () {
        this.startTimer();
    };
    Notice.prototype.componentDidUpdate = function (nextProps) {
        if (nextProps.duration !== this.props.duration || this.props.update) {
            this.removeTimer();
            this.startTimer();
        }
    };
    Notice.prototype.componentWillUnmount = function () {
        this.removeTimer();
    };
    Notice.prototype.render = function () {
        var _a = this.props, title = _a.title, content = _a.content, showIcon = _a.showIcon, icon = _a.icon, className = _a.className, style = _a.style, type = _a.type, btn = _a.btn, prefixCls = _a.prefixCls, noticeType = _a.noticeType;
        var classNames = cs(prefixCls, prefixCls + "-" + type, className);
        if (noticeType === 'message') {
            return (React.createElement("div", { style: { textAlign: 'center' } },
                React.createElement("div", { className: classNames, style: style },
                    showIcon || icon ? this.renderIcon() : null,
                    React.createElement("span", null, content))));
        }
        if (noticeType === 'notification') {
            return (React.createElement("div", { className: classNames, style: style },
                showIcon || icon ? React.createElement("div", { className: prefixCls + "-left" }, this.renderIcon()) : null,
                React.createElement("div", { className: prefixCls + "-right" },
                    title && React.createElement("div", { className: prefixCls + "-title" }, title),
                    React.createElement("div", { className: prefixCls + "-content" }, content),
                    btn && React.createElement("div", { className: prefixCls + "-btn-wrapper" }, btn)),
                React.createElement(IconClose, { onClick: this.onClose })));
        }
    };
    Notice.propTypes = {
        className: PropTypes.string,
        content: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        icon: PropTypes.element,
        showIcon: PropTypes.bool,
        style: PropTypes.object,
        title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
        type: PropTypes.string,
        btn: PropTypes.element,
    };
    Notice.defaultProps = {
        style: {},
        type: 'info',
        showIcon: true,
        noticeType: 'message',
        duration: 3000,
    };
    return Notice;
}(Component));
export default Notice;
